import _ from "lodash";

const { localStorage } = window;
// console.log("Saving preferences", identityId, prefs);

export function save(key, value) {
	localStorage.setItem(key, !_.isString(value) ? JSON.stringify(value) : value);
}

export function get(key) {
	let value = localStorage.getItem(key);
	if (value) {
		try {
			value = JSON.parse(value);
		} catch (e) {
			console.warn("Failed to parse localStorage value", value, e);
		}
	}
	return value;
}